import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import Problem from "@/components/Problem";
import ReviewCollection from "@/components/ReviewCollection";
import AIAgents from "@/components/AIAgents";
import Flywheel from "@/components/Flywheel";
import Benefits from "@/components/Benefits";
import HowItWorks from "@/components/HowItWorks";
import VideoShowcase from "@/components/VideoShowcase";
import Pricing from "@/components/Pricing";
import ComparisonTable from "@/components/ComparisonTable";
import Testimonials from "@/components/Testimonials";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="App min-h-screen bg-base">
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <Problem />
        <ReviewCollection />
        <AIAgents />
        <Flywheel />
        <Benefits />
        <HowItWorks />
        <VideoShowcase />
        <Pricing />
        <ComparisonTable />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
